import { gql } from "@apollo/client";

export const MUTATION_UPDATE_TRACKING = gql`
  mutation updateTrackingMutation(
    $featureInstanceIds: [String!]!
    $isTracked: Boolean!
  ) {
    update_feature_tracking(
      featureInstanceIds: $featureInstanceIds
      isTracked: $isTracked
    ) {
      message
      updatedCount
      updatedFeatureInstanceIds
    }
  }
`;
